export function roundToTwoDecimalsIfDecimal(value?: number | string) {
  if (value === undefined) return;
  const valueAsNumber = typeof value === 'string' ? Number(value) : value;

  if (valueAsNumber % 1 !== 0) {
    return valueAsNumber?.toFixed(2);
  }
  return valueAsNumber;
}
